import { Sequence, useCurrentFrame } from 'remotion';
import { ReactNode, useMemo } from 'react';

// Types
import { TrainingFeedbackData } from '../types';

// Components
import { TrainingFeedbackCard } from './TrainingFeedbackCard';

// Utils
import { getVisibleTrainingFeedbacks } from '../utils';

export interface MainContentProps {
  feedbacks?: TrainingFeedbackData[];
  /** Delay in frames before animations start (for transition overlap) */
  animationDelay?: number;
}

export const MainContent = ({
  feedbacks = [],
  animationDelay = 0,
}: MainContentProps): ReactNode => {
  const rawFrame = useCurrentFrame();
  // Apply animation delay
  const frame = Math.max(0, rawFrame - animationDelay);

  // All feedback items with animation timings and visibility state
  const feedbackItems = useMemo(
    () =>
      getVisibleTrainingFeedbacks({
        feedbacks,
        currentFrame: frame,
        animationDelay,
      }),
    [feedbacks, frame, animationDelay],
  );

  return (
    <Sequence name="Main Content" className="flex-center">
      {feedbackItems
        .filter(({ isVisible }) => isVisible)
        .map(
          ({ feedback, index, startFrame, transitionStartFrame, variant }) => (
            <TrainingFeedbackCard
              key={`training-feedback-${index}`}
              {...feedback}
              variant={variant}
              startFrame={startFrame}
              transitionStartFrame={transitionStartFrame}
            />
          ),
        )}
    </Sequence>
  );
};
